/*
================================================================
	Copyright © 2020, Cheers Interactive Pvt Ltd.  All rights reserved.
	  File Description : Dynamic BreadCrumb Component
----------------------------------------------------------------
	Creation Details
	Date Created				: 28/Jul/2020
	Author						: YOGESH N. GUPTA
================================================================
*/

import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const BreadCrumbUI = () => {
  const { breadCrumbsLinks = [] } = useSelector((state) => state.breadCrumbState || {});

  if (!breadCrumbsLinks?.length) return null;

  return (
    <div className="breadcrumbs" data-length={breadCrumbsLinks?.length < 2 ? 1 : 0}>
      {" "}
      {/* Hides breadcrumbs if the length is less than 2 */}
      <div className="container-fluid">
        <ul>
          {breadCrumbsLinks.map((bCL, i) => {
            // Capitalizes the first letter of each word in linkName and converts the rest to lowercase
            const formattedName = bCL?.linkName
              ?.split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(" ");
            const isSingleLink = breadCrumbsLinks.length === 1;

            if (!bCL.linkActive) {
              return (
                <li key={`${bCL?.linkName + i}`} className="mr-2">
                  <Link to={bCL?.linkUrl}>{formattedName}</Link>
                  <i className="fas fa-angle-right ml-2" aria-hidden="true" />
                </li>
              );
            }

            return isSingleLink ? null : <li key={`${bCL?.linkName + i}`}>{formattedName}</li>;
          })}
        </ul>
      </div>
    </div>
  );
};

export default BreadCrumbUI;
